import { IVan } from '../../../../../app/entities/Van'

export const initialVanValues: IVan = {
  created: 0,
  updated: 0,
  dotEndDate: null as unknown as Date,
  inServiceDate: null as unknown as Date,
  lastDvir: null as unknown as Date,
  lastMvir: null as unknown as Date,
  lastWvir: null as unknown as Date,
  licensePlate: '',
  livery: '',
  make: '',
  model: '',
  name: '',
  objectId: '',
  outOfServiceDate: null as unknown as Date,
  operatingStatus: undefined,
  operatingStatusStartDate: null as unknown as Date,
  vanFixPendingApproval: false,
  activeWithUnresolvedIssue: false,
  assignedTo: null,
  issue: undefined,
  registrationEndDate: null as unknown as Date,
  samsaraId: 0,
  vin: '',
  year: undefined,
  location: undefined,
  order: [],
  images: [],
  vir: [],
  vanBatteryDataBindings: [],
  operatingStatusHistory: [],
}
